module.exports = __webpack_public_path__ + "img/ico-arrow-left.d655c010.svg";